import React from 'react'

export default function MainContentWrapper({ children }) {
    return (
        <main className="w-full h-full">
            {children}
        </main>
    )
}
